import React, { Component } from "react";

import { shuffle } from "./helpers";

import ReactGA from "react-ga";

import AppContext from "./AppContext";
import Result from "./Result";
import Variants from "./Variants";

class Quiz extends Component {
  static contextType = AppContext;

  state = {
    progress: 0,
    question: null,
    selection: null,
    answers: []
  };

  constructor() {
    super();
  }

  componentWillMount() {
      let {QUIZ} = this.context;
      QUIZ = shuffle(QUIZ);
    this.setState({ question: QUIZ[0], QUIZ });
    ReactGA.pageview('/question/1');
    ReactGA.event({
        category: "quiz",
        action: `question/1`
      });
  }

  setActiveVariant(variant) {
    this.setState({ selection: variant });
  }

  proceed() {
    this.setState(prevState => {
      const state = prevState;
      state.answers.push(prevState.selection.correct);
      state.selection = null;
      state.question = this.context.QUIZ[state.answers.length];
      ReactGA.pageview(`/question/${state.answers.length+1}`);
      ReactGA.event({
        category: "quiz",
        action: `question/${state.answers.length+1}`
      });
      return state;
    });
  }

  redo() {
    const QUIZ = shuffle(this.context.QUIZ);
    this.setState({
      progress: 0,
      selection: null,
      answers: [],
      QUIZ,
      question: QUIZ[0]
    });
  }

  render() {
    const {QUIZ} = this.state;

    if (this.state.answers.length === QUIZ.length) {
      ReactGA.event({
        category: "quiz",
        action: "finished",
        value: this.state.answers.filter(a => a === true).length
      });

      ReactGA.pageview(`/result`);

      return <Result answers={this.state.answers} QUIZ={QUIZ} redo={() => this.redo()}/>
    }

    return (
      <section className="section">
        <div className="container">
          <div className="level columns is-mobile is-centered">
            <div className="column is-four-fifths">
              <progress
                className="progress"
                value={
                  this.state.answers.length
                    ? (this.state.answers.length / QUIZ.length) * 100
                    : 0
                }
                max="100"
              >
                {this.state.answers.length
                  ? this.state.answers.length / QUIZ.length
                  : 0}
                %
              </progress>
            </div>
            <div className="column">
              <div
                className="level-item title"
                style={{ whiteSpace: "nowrap" }}
              >
                {this.state.answers.length}/{QUIZ.length}
              </div>
            </div>
          </div>
          <Variants
            question={this.state.question}
            onSelection={variant => {
              this.setState({ selection: variant });
            }}
          />
          <div className="level is-mobile">
            <div className="level-left" />
            <div className="level-right">
              <button
                className={["button"].join(" ")}
                disabled={!this.state.selection}
                onClick={() => {
                  if (this.state.selection === null) {
                    return;
                  }
                  this.proceed();
                }}
              >
                Дальше
              </button>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Quiz;
